export class Agent {
  public id: string;
  public machineName: string;
  public type: number;
}
